export default __webpack_public_path__ + "static/media/esgDay.35d09d9d.png";